import React from "react";
import ic_filter from "./../../../assets/ic_filter.svg";
import ic_360degree_view from "./../../../assets/ic_360degree_view.svg";

export default function MyServiceRequestsFilterSection(props)
{
    return (
        <>
            <div className="col-12 lpm-filter-section conv-pl40 conv-pr40 conv-fixed-header">
                <div className="row conv-mt20 conv-mb20">
                    <div className="col-12">
                        <button className="lpm-con-btn-filled conv-pl15 conv-pr15 conv-font14"
                            onClick={(e)=>{ props.toggleFilterModal()}} >
                            <img
                                alt=""
                                src={ic_filter}
                                height={"15px"}
                                width={"15px"}
                                className="conv-mr10"
                            />
                            Filter By
                        </button>

                        <button className="notification todays-tasks conv-ml40">
                            My Today's Task
                            <div className="notification-dot">{props.serviceRequestCount}</div>
                        </button>

                        <button className="notification todays-tasks conv-ml40">
                            Tasks Handled Today
                            <div className="notification-dot">{props.serviceRequestHandledTodayCount}</div>
                        </button>

                        <button className="notification todays-tasks conv-ml40">
                            Remaining Tasks
                            <div className="notification-dot">{props.RemainingServiceRequestCount}</div>
                        </button>

                        <a className="conv-float-right con-cursor-pointer"
                           href="/home/three-sixty-degree-view-new/"target="_blank">
                            <img
                                alt=""
                                src={ic_360degree_view}
                                height={"15px"}
                                width={"21px"}
                                className="conv-mr10"
                            />
                            <span className="link360-view-text">
                                360 Degree View
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </>
        );
}